import { createApiSlice } from "@common";
import { CRUD_PERSONAL_BLOOD_GROUP } from "@routes";

const apiConfig = [
  {
    name: "addPersonalBloodGroup",
    method: "post",
    url: CRUD_PERSONAL_BLOOD_GROUP,
    stateKey: "message",
  },

  {
    name: "getPersonalBloodGroup",
    method: "get",
    url: CRUD_PERSONAL_BLOOD_GROUP,
    stateKey: "data",
  },

  {
    name: "updatePersonalBloodGroup",
    method: "put",
    url: CRUD_PERSONAL_BLOOD_GROUP,
    stateKey: "message",
  },

  {
    name: "deletePersonalBloodGroup",
    method: "delete",
    url: CRUD_PERSONAL_BLOOD_GROUP,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "PersonalBloodGroup",
  apiConfig,
  customReducers);
const PersonalBloodGroupSlice = slice;

export default PersonalBloodGroupSlice.reducer;

export const {
  addPersonalBloodGroup,
  getPersonalBloodGroup,
  updatePersonalBloodGroup,
  deletePersonalBloodGroup,
} = thunks;

export const { rowSelect } = actions;
